const componentsContext = require.context("./src", true, /\.vue$/);
const res = {};
componentsContext.keys().forEach(componentPath => {
  const componentKey = componentPath.replace(/^.\/(.*)\.\w+$/, "$1");
  res[componentKey] = componentsContext(componentPath).default;
});
module.exports = res;